import type { FeedbackMessages } from './en';

const es: FeedbackMessages = {
  qualified: {
    title: '¡Gracias por completar este estudio!',
    text: 'Ya puede cerrar la ventana del navegador.\n\nEsperamos volver a verlo pronto.',
  },
  quotaFull: {
    title: 'Este estudio está cerrado',
    text: 'Gracias por su interés en nuestro estudio.\n\nLamentablemente, ya hemos recibido todas las respuestas que necesitábamos.\n\n¡Esperamos contar con usted en uno de nuestros futuros estudios!',
  },
  terminated: {
    title: '¡Gracias por compartir sus comentarios!',
    text: 'Esperamos contar con usted próximamente en nuestros futuros estudios. Mientras tanto, le deseamos un excelente día.\n\nPor favor, cierre esta ventana del navegador.',
  },
  mismatch: {
    title: 'Gracias por su interés',
    text: 'Lamentablemente, usted no forma parte del grupo objetivo de este estudio en particular.\n\nPuede cerrar esta página.',
  },
  error: {
    title: 'No podemos procesar su solicitud',
    linkProblemDetailed:
      'El enlace que ha seguido presenta problemas. Verifique que el enlace en la barra de direcciones coincida con el que se le proporcionó e inténtelo de nuevo.',
    linkProblemGeneric:
      'El enlace que ha seguido presenta problemas. Por favor, inténtelo de nuevo.',
    contactPerson:
      'Si el problema persiste, informe de esta incidencia a la persona que le proporcionó el enlace.',
  },
};

export default es;
